import { ChangeDetectorRef, Component, EventEmitter, inject, Output } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms'
import { NgOptimizedImage } from '@angular/common';
import { GoogleDrivePickerService } from '../../service/google-drive-picker.service'
import { GooglePickerData } from '../../models/google-picker'
import { googleDriveLinkValidator } from '../../validators/drive-link.validator'

@Component({
    selector: 'app-upload-drive-link-modal',
    standalone: true,
    imports: [ReactiveFormsModule, NgOptimizedImage],
    templateUrl: './upload-drive-link-modal.component.html',
    styleUrl: './upload-drive-link-modal.component.scss',
})
export class UploadDriveLinkModalComponent {
    private cdr = inject(ChangeDetectorRef);

    protected readonly drivePickerOnModal = 'assets/images/logos/GOOGLE_DRIVE_PICKER.svg'

    private modalRef = inject(NgbActiveModal)
    private fb = inject(FormBuilder)
    private drivePickerService = inject(GoogleDrivePickerService)
    form: FormGroup

    @Output()
    submitForm = new EventEmitter<DocumentUploadModalFormValue>()

    constructor() {
        this.form = this.fb.group({
            fileName: ['', [Validators.required]],
            lienDocumentDrive: ['', [Validators.required, googleDriveLinkValidator()]],
        })
    }

    openDrivePicker(): void {
        this.drivePickerService.openGooglePicker((oauthToken: string, data: GooglePickerData) => {
            this.pickerCallback(oauthToken, data)
        })
    }

    pickerCallback(oauthToken: string, data: GooglePickerData): void {
        if (data.action === 'picked' && data.docs.length > 0) {
            const selectedFile = data.docs[0]

            this.form.patchValue({
                fileName: this.form.get('fileName').value || selectedFile.name,
                lienDocumentDrive: selectedFile.url,
            })
            this.cdr.detectChanges()
        }
    }

    onSubmit(): void {
        if (this.form.valid) {
            this.submitForm.emit({
                fileName: this.form.value.fileName,
                lienDocumentDrive: this.form.value.lienDocumentDrive,
            })
            this.modalRef.close()
        }
    }

    onCloseModal(): void {
        this.modalRef.dismiss()
    }
}

export interface DocumentUploadModalFormValue {
    fileName: string
    lienDocumentDrive: string
}
